import { memo } from 'react';

import { useStore } from '@spazious/dollhouse-store';

import { MeasurementDrawControls } from '../MeasurementDrawControls/index.js';

export const MeasurementControls = memo(() => {
  const { measurements } = useStore();

  return measurements.drawEnabled ? <MeasurementDrawControls /> : null;
});
